import { Menu } from "antd";
import { Form, Formik, FormikValues } from "formik";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Api } from "../ApiLinkedButton";
import { EBModalV2 } from "../EBModalV2";

interface ApiLinkedMenuItemProps {
  api: Api<any, any>;
  uniqueKey: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  apiFormBody?: React.ReactNode;
  formModalSize?: "sm" | "md" | "xl";
  initialValues?: any;
  successCallback?: (response: any) => Promise<void>;
  disabled?: boolean;
}

export function ApiLinkedMenuItem(props: ApiLinkedMenuItemProps) {
  let [isSubmitting, setSubmitting] = useState<boolean>(false);
  let modalId = props.uniqueKey + "-modal";
  let modalCloseBtnId = props.uniqueKey + "-modal-close-button";

  function submit() {
    setSubmitting(true);
    props.api
      .executeV2(props.initialValues)
      .then((response) => {
        if (props.successCallback) {
          return props.successCallback(response);
        }
        return response;
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  const handleClick = (e: any) => {
    if (!props.apiFormBody) {
      submit();
    }
    // If apiFormBody exists, Bootstrap data-bs-toggle will handle it, 
    // but we might need to stop propagation if it's inside another click handler.
    e.domEvent?.stopPropagation();
  };

  return (
    <>
      <Menu.Item
        key={props.uniqueKey}
        icon={props.icon}
        disabled={props.disabled || isSubmitting}
        onClick={handleClick}
        {...(props.apiFormBody
          ? {
              "data-bs-toggle": "modal",
              "data-bs-target": "#" + modalId,
            }
          : {})}
      >
        {props.label}
      </Menu.Item>

      {props.apiFormBody &&
        (createPortal(
          <>
            <Formik
              initialValues={props.initialValues ?? {}}
              onSubmit={function (values: FormikValues) {
                setSubmitting(true);
                props.api
                  .executeV2(values)
                  .then((response) => {
                    document.getElementById(modalCloseBtnId)?.click();
                    if (props.successCallback) {
                      return props.successCallback(response);
                    }
                    return response;
                  })
                  .catch(() => {
                    document.getElementById(modalCloseBtnId)?.click();
                  })
                  .finally(() => {
                    setSubmitting(false);
                  });
              }}
            >
              {(formProps) => (
                <Form>
                  <EBModalV2
                    body={<div>{props.apiFormBody}</div>}
                    id={modalId}
                    modalSize={props.formModalSize}
                    primaryButtonProps={{
                      content: { normal: "Submit", submitting: "Submitting..." }, // Default content
                      type: "submit",
                      disabled: isSubmitting || props.disabled,
                      loading: isSubmitting,
                      purpose: "primary",
                    }}
                    closeButtonId={modalCloseBtnId}
                  />
                </Form>
              )}
            </Formik>
          </>,
          document.body
        ) as any)}
    </>
  );
}
